import styled from '@emotion/styled';

type Colour = 'green' | 'blue';

const colourMap: Record<Colour, string> = {
	green: '#D1F7E9',
	blue: '#EBF7FF',
};

export const GradientInfoCardWithImageStyled = styled.div<{ colour: Colour }>`
	display: flex;
	padding: 24px;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	flex: 1 0 0;
	overflow: hidden;

	border-radius: 16px;
	border: 1px solid rgba(5, 42, 128, 0.1);
	background: radial-gradient(
		126.16% 71.21% at 46.76% 100%,
		${({ colour }) => colourMap[colour]} 0%,
		#fff 100%
	);

	height: 366px;
	min-width: 272px;
	position: relative;

	> h3 {
		color: #11233a;
		font-size: 18px;
		font-family: Inter;
		font-weight: 700;
		line-height: 125%;
		letter-spacing: -0.26px;
		margin: 0;
	}

	> img {
		align-self: center;

		position: absolute;
		top: 55%;

		max-width: none;
		width: 481px;
		height: 336px;
	}
`;

export const GradientOverlay = styled.div<{ colour: Colour }>`
	width: 100%;
	height: 140px;
	position: absolute;
	left: 0;
	bottom: 0;
	background: linear-gradient(
		0deg,
		${({ colour }) => colourMap[colour]} 0%,
		rgba(255, 255, 255, 0) 100%
	);
`;
